export default __webpack_public_path__ + "static/media/0xb382c1cfa622795a534e5bd56fac93d59bac8b0d.04482a56.webp";